import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    ref: "chat",
    id: "chat",
    class: "full-height"
};
const _hoisted_2 = {
    class: "full-width",
    ref: "contentRef"
};
const _hoisted_3 = {
    key: 0,
    class: "row justify-center"
};
const _hoisted_4 = {
    key: 1,
    class: "row text-center justify-center custom-text-b11"
};
const _hoisted_5 = {
    key: 0,
    class: "row text-center justify-center custom-text-b11 q-pb-xs"
};
const _hoisted_6 = { class: "row justify-center q-pt-sm q-pb-sm" };
const _hoisted_7 = {
    key: 7,
    class: "row text-center justify-center custom-text-b11 q-py-xs"
};
const _hoisted_8 = { class: "col-12 normal-break" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "q-pa-sm" };
const _hoisted_11 = { class: "row justify-center" };
const _hoisted_12 = {
    key: 0,
    class: "row justify-center q-pt-md"
};
const _hoisted_13 = { class: "col-12 text-center q-pt-md" };
const _hoisted_14 = ["href", "target"];
const _hoisted_15 = {
    key: 1,
    class: "row justify-center q-pt-md"
};
const _hoisted_16 = { class: "col-12 text-center q-pt-md" };
const _hoisted_17 = ["href", "target"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_chat_header = _resolveComponent("chat-header");
    const _component_q_spinner = _resolveComponent("q-spinner");
    const _component_q_scroll_observer = _resolveComponent("q-scroll-observer");
    const _component_q_badge = _resolveComponent("q-badge");
    const _component_txt_msg = _resolveComponent("txt-msg");
    const _component_img_msg = _resolveComponent("img-msg");
    const _component_file_msg = _resolveComponent("file-msg");
    const _component_order_msg = _resolveComponent("order-msg");
    const _component_video_msg = _resolveComponent("video-msg");
    const _component_listing_msg = _resolveComponent("listing-msg");
    const _component_q_chat_message = _resolveComponent("q-chat-message");
    const _component_report = _resolveComponent("report");
    const _component_uploading_msg = _resolveComponent("uploading-msg");
    const _component_upload_error_msg = _resolveComponent("upload-error-msg");
    const _component_q_scroll_area = _resolveComponent("q-scroll-area");
    const _component_chat_input = _resolveComponent("chat-input");
    const _component_pre_upload_dialog = _resolveComponent("pre-upload-dialog");
    const _component_full_screen_img = _resolveComponent("full-screen-img");
    const _component_custom_order = _resolveComponent("custom-order");
    const _component_host_details_dialog = _resolveComponent("host-details-dialog");
    const _component_user_details_dialog = _resolveComponent("user-details-dialog");
    const _component_play_video = _resolveComponent("play-video");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_router_link = _resolveComponent("router-link");
    const _component_general_dialog = _resolveComponent("general-dialog");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_chat_header, {
            "app-type": _ctx.appType,
            "back-label": _ctx.backLabel,
            "is-chat-user": _ctx.isChatUser,
            listing: _ctx.listing,
            "listing-is-active": _ctx.listingIsActive,
            "listing-loading": _ctx.listingIsActive.active === null,
            receiver: _ctx.receiver,
            "route-string": _ctx.routeString,
            onCloseChat: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close-chat'))),
            onCreateCustomOrder: _ctx.showCustomOrder,
            ref: "chatHeadRef"
        }, null, 8, ["app-type", "back-label", "is-chat-user", "listing", "listing-is-active", "listing-loading", "receiver", "route-string", "onCreateCustomOrder"]),
        _createVNode(_component_q_scroll_area, {
            ref: "chatAreaRef",
            "thumb-style": _ctx.thumbStyle,
            class: _normalizeClass(["q-mx-sm", {
                    ..._ctx.chatAreaHeightClass
                }])
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, null, 512),
                (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_q_spinner, {
                            color: "accent",
                            size: "3em",
                            thickness: 2
                        })
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_q_scroll_observer, { onScroll: _ctx.scrollHandler }, null, 8, ["onScroll"]),
                (!_ctx.processedMsg)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.disclaimer), 1))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedMsg, (datesets, dateindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: `date${dateindex}`,
                        class: "q-pr-sm"
                    }, [
                        (datesets.messages && (datesets.messages.length > 0) && (Number(dateindex) === 0) && _ctx.noPrevMsgs)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.disclaimer), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_q_badge, { color: "positive" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(datesets.date), 1)
                                ]),
                                _: 2
                            }, 1024)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datesets.messages, (value, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: `msg${index}`,
                                class: "q-pl-xs",
                                style: _normalizeStyle({
                                    'max-width': _ctx.styleType === 'desktop'
                                        ? '320px'
                                        : 'calc(100vw - 36px)'
                                }),
                                ref_for: true,
                                ref: el => { _ctx.references[`msg-${value.id}`] = el; }
                            }, [
                                (value.type === 'text')
                                    ? (_openBlock(), _createBlock(_component_txt_msg, {
                                        key: 0,
                                        msg: value
                                    }, null, 8, ["msg"]))
                                    : ((value.type === 'image'))
                                        ? (_openBlock(), _createBlock(_component_img_msg, {
                                            key: 1,
                                            onShowPic: _ctx.enlargePic,
                                            "convo-id": _ctx.convo.id,
                                            "image-width": _ctx.imageWidth,
                                            msg: value
                                        }, null, 8, ["onShowPic", "convo-id", "image-width", "msg"]))
                                        : ((value.type === 'attachment'))
                                            ? (_openBlock(), _createBlock(_component_file_msg, {
                                                key: 2,
                                                msg: value
                                            }, null, 8, ["msg"]))
                                            : (value.type === 'custom_order')
                                                ? (_openBlock(), _createBlock(_component_order_msg, {
                                                    key: 3,
                                                    msg: value,
                                                    "convo-id": _ctx.convo.id,
                                                    "is-chat-user": _ctx.isChatUser,
                                                    "receiver-name": _ctx.convo.receiver_name,
                                                    "route-string": _ctx.routeString,
                                                    onShowOrder: _ctx.showTempOrderDetails,
                                                    onOrderCanceled: ($event) => (_ctx.cancelTempOrder(dateindex, index))
                                                }, null, 8, ["msg", "convo-id", "is-chat-user", "receiver-name", "route-string", "onShowOrder", "onOrderCanceled"]))
                                                : (value.type === 'video')
                                                    ? (_openBlock(), _createBlock(_component_video_msg, {
                                                        key: 4,
                                                        msg: value,
                                                        onShowVideo: _ctx.showVideo
                                                    }, null, 8, ["msg", "onShowVideo"]))
                                                    : (value.type === 'listing')
                                                        ? (_openBlock(), _createBlock(_component_listing_msg, {
                                                            key: 5,
                                                            msg: value
                                                        }, null, 8, ["msg"]))
                                                        : (_openBlock(), _createBlock(_component_q_chat_message, {
                                                            key: 6,
                                                            size: _ctx.messagewidth,
                                                            sent: _ctx.isSender(value),
                                                            text: value.text,
                                                            "bg-color": _ctx.chatBg(value),
                                                            "text-color": _ctx.chatTxt(value)
                                                        }, {
                                                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                                _createElementVNode("div", null, " (Message type is not supported. Please update your app version) ", -1)
                                                            ])),
                                                            _: 2
                                                        }, 1032, ["size", "sent", "text", "bg-color", "text-color"])),
                                (value.has_sensitive_info)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _createTextVNode(_toDisplayString(_ctx.disclaimer) + " ", 1),
                                            _createVNode(_component_report, null, {
                                                "report-btn": _withCtx(({ report }) => [
                                                    (_ctx.isChatUser)
                                                        ? (_openBlock(), _createElementBlock("span", {
                                                            key: 0,
                                                            class: "text-accent q-pl-xs cursor-pointer text-weight-bold",
                                                            onClick: ($event) => (report({
                                                                firebase_chat_room_reported_msg_id: value.id || '',
                                                                firebase_chat_room_reported_msg: value.lastMsg || ''
                                                            }))
                                                        }, " Report host ", 8, _hoisted_9))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 4));
                        }), 128))
                    ]));
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadQueue, (value, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: `temp${index}`
                    }, [
                        _createVNode(_component_uploading_msg, {
                            msg: value,
                            "image-width": _ctx.imageWidth,
                            "upload-progress": _ctx.uploadProgress
                        }, null, 8, ["msg", "image-width", "upload-progress"])
                    ]));
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorStore, (value, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: `err${index}`
                    }, [
                        _createVNode(_component_upload_error_msg, {
                            msg: value,
                            onReupload: ($event) => (_ctx.reupload$.next(index))
                        }, null, 8, ["msg", "onReupload"])
                    ]));
                }), 128))
            ]),
            _: 1
        }, 8, ["thumb-style", "class"]),
        _createVNode(_component_chat_input, {
            uploadable: "",
            "prevent-blank": "",
            onInput: _ctx.updateTyping,
            onUploadFile: _ctx.beforeUpload,
            onSendMessage: _ctx.sendTxt,
            onUpdateInputHeight: _ctx.updateInputHeight,
            onCustomOrder: _ctx.showCustomOrder,
            "app-type": _ctx.appType,
            "is-chat-user": _ctx.isChatUser,
            listing: _ctx.listing,
            "listing-loading": _ctx.listingIsActive.active === null,
            "video-count": _ctx.videoCount,
            "other-listing-count": _ctx.otherListingCount,
            receiver: _ctx.receiver,
            ref: "chatInputRef",
            class: "full-width q-pa-sm white-dark-background"
        }, null, 8, ["onInput", "onUploadFile", "onSendMessage", "onUpdateInputHeight", "onCustomOrder", "app-type", "is-chat-user", "listing", "listing-loading", "video-count", "other-listing-count", "receiver"]),
        _createVNode(_component_pre_upload_dialog, {
            ref: "preUploadDialogRef",
            onUpload: _cache[1] || (_cache[1] = ($event) => (_ctx.upload$.next($event)))
        }, null, 512),
        _createVNode(_component_full_screen_img, {
            show: _ctx.fullScreen,
            "onUpdate:show": _cache[2] || (_cache[2] = ($event) => ((_ctx.fullScreen) = $event)),
            "file-src": _ctx.fileSrc
        }, null, 8, ["show", "file-src"]),
        (_ctx.customOrderDialog && (_ctx.appType === 'getspaces') && !_ctx.isChatUser)
            ? (_openBlock(), _createBlock(_component_custom_order, {
                key: 0,
                show: _ctx.customOrderDialog,
                "onUpdate:show": _ctx.closeCustomOrder,
                "listing-id": _ctx.customListingId,
                "order-for": _ctx.receiver,
                onTempOrderCreated: _ctx.tempOrderCreated,
                "use-day-range": ""
            }, null, 8, ["show", "onUpdate:show", "listing-id", "order-for", "onTempOrderCreated"]))
            : _createCommentVNode("", true),
        (_ctx.showDetails && _ctx.customOrderId && !_ctx.isChatUser)
            ? (_openBlock(), _createBlock(_component_host_details_dialog, {
                key: 1,
                "order-id": _ctx.customOrderId,
                "show-dialog": _ctx.showDetails,
                "onUpdate:showDialog": _ctx.closeTempOrderDetails
            }, null, 8, ["order-id", "show-dialog", "onUpdate:showDialog"]))
            : (_ctx.showDetails && _ctx.customOrderId)
                ? (_openBlock(), _createBlock(_component_user_details_dialog, {
                    key: 2,
                    "order-id": _ctx.customOrderId,
                    "show-dialog": _ctx.showDetails,
                    "onUpdate:showDialog": _ctx.closeTempOrderDetails
                }, null, 8, ["order-id", "show-dialog", "onUpdate:showDialog"]))
                : _createCommentVNode("", true),
        _createVNode(_component_play_video, {
            ref: "playVideoRef",
            "venue-name": _ctx.listing.name,
            show: _ctx.videoDialogShow,
            "play-video": _ctx.playVideoUrl,
            onHide: _ctx.hideVideo
        }, null, 8, ["venue-name", "show", "play-video", "onHide"]),
        _createVNode(_component_general_dialog, {
            modelValue: _ctx.listingInactiveDialog,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.listingInactiveDialog) = $event)),
            title: "Listing is inactive",
            width: "500px"
        }, {
            content: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_q_icon, {
                            name: "close",
                            color: "accent",
                            size: "5rem"
                        })
                    ]),
                    (!_ctx.listingIsActive.active)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-12 text-center text-body1 normal-break" }, " Your listing is currently inactive. Reactivate it to continue creating order ", -1)),
                            _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_router_link, {
                                    to: {
                                        name: 'Edit Listings',
                                        params: {
                                            id: _ctx.listing.id
                                        }
                                    },
                                    custom: ""
                                }, {
                                    default: _withCtx(({ href }) => [
                                        _createElementVNode("a", {
                                            href: href,
                                            target: _ctx.styleType === 'app' ? '_self' : '_blank',
                                            class: "row"
                                        }, [
                                            _createVNode(_component_q_btn, {
                                                color: "primary",
                                                label: "Reactivate",
                                                class: "col-12"
                                            })
                                        ], 8, _hoisted_14)
                                    ]),
                                    _: 1
                                }, 8, ["to"])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (!_ctx.listingIsActive.approved)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-12 text-center text-body1 normal-break" }, " Your listing is currently not approved by our admin. Contact us to expedite this request ", -1)),
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_router_link, {
                                    to: {
                                        name: 'Contact Us',
                                    },
                                    custom: ""
                                }, {
                                    default: _withCtx(({ href }) => [
                                        _createElementVNode("a", {
                                            href: href,
                                            target: _ctx.styleType === 'app' ? '_self' : '_blank',
                                            class: "row"
                                        }, [
                                            _createVNode(_component_q_btn, {
                                                color: "positive",
                                                label: "Contact Us",
                                                class: "col-12"
                                            })
                                        ], 8, _hoisted_17)
                                    ]),
                                    _: 1
                                })
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _: 1
        }, 8, ["modelValue"])
    ], 512));
}
